import { useCallback, useMemo } from "react";
import type { GroundSupplier } from "@b2bportal/ground-api";
import type { FilterSuppliersProps } from "./FilterSuppliers";

export const useFilterSuppliers = ({
  selectedValues,
  options,
  onChange,
}: FilterSuppliersProps) => {
  const items = options.map((c) => ({
    label: c.name,
    value: c.name,
  }));

  const getSelectedSupplier = useCallback(
    (selectedItems: string[]): GroundSupplier[] => {
      return (
        selectedItems
          .map((i) => {
            return options.find((o) => o.name === i) ?? null;
          })
          .filter((x): x is GroundSupplier => x !== null) ?? []
      );
    },
    [options]
  );

  return useMemo(
    () => ({ selectedValues, onChange, items, getSelectedSupplier }),
    [getSelectedSupplier, items, onChange, selectedValues]
  );
};
